const TrainerFeedback = (props) => {
  const { feedback } = props;

  function formatDateOnly(dateString) {
    if (!dateString) return "";

    const date = new Date(dateString);
    if (isNaN(date)) return "";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
  }
  return (
    <div className="trainer-feedback">
      <div className="trainer-feedback-title">Trainer Feedback</div>
      <div className="trainer-data-fields">
        {feedback.length > 0 ? (
          feedback.map((fb, i) => (
            <div className="trainer-data feedback" key={i}>
              <div className="field-row">
                <div className="trainer-field-label">Coinvolgimento: </div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {fb.feedbackCoinvolgimento}
                  </span>
                </div>
              </div>
              <div className="field-row">
                <div className="trainer-field-label">Partecipanti: </div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {fb.feedbackPartecipanti}
                  </span>
                </div>
              </div>
              <div className="field-row">
                <div className="trainer-field-label">Tutor: </div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">{fb.feedbackTutor}</span>
                </div>
              </div>
              <div className="field-row">
                <div className="trainer-field-label">Efficacia: </div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {fb.feedbackEfficacia}
                  </span>
                </div>
              </div>
              <div className="field-row">
                <div className="trainer-field-label">Note Aggiuntive: </div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {fb.noteAggiuntive}
                  </span>
                </div>
              </div>
              <div className="field-row">
                <div className="trainer-field-label">Punteggio Totale: </div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {fb.punteggioTotale}
                  </span>
                </div>
              </div>
              <div className="field-row">
                <div className="trainer-field-label">Data Inserimento: </div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {formatDateOnly(fb.dataInserimento)}
                  </span>
                </div>
              </div>
              <div className="field-row">
                <div className="trainer-field-label">Autore: </div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">{fb.autore}</span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="no-data">Nessun feedback </div>
        )}
      </div>
    </div>
  );
};

export default TrainerFeedback;
